/**
 * @generated SignedSource<<1de0968c94573ce189c43b8077ee7f3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetIntegrationNotificationSettingInput = {
  teamSetting?: string | null;
  personId?: string | null;
  value?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SetIntegrationNotificationSettingMutation$variables = {
  input: SetIntegrationNotificationSettingInput;
};
export type SetIntegrationNotificationSettingMutation$data = {
  readonly setIntegrationNotificationSetting: {
    readonly teamsNotificationSettings: {
      readonly disableNotifications: boolean | null;
      readonly notifyOnProjectStatusChange: boolean | null;
      readonly notifyOnAssignedProject: boolean | null;
      readonly notifyOnPersonJoin: boolean | null;
      readonly notifyOnProjectDeadline: boolean | null;
      readonly notifyOnAssignedTask: boolean | null;
      readonly notifyOnAssignedTaskUpdate: boolean | null;
      readonly notifyOnTaskDeadline: boolean | null;
      readonly notifyOnMention: boolean | null;
      readonly notifyOnTaskDescriptionChange: boolean | null;
      readonly notifyOnTaskTitleChange: boolean | null;
      readonly notifyOnTaskEstimateChange: boolean | null;
      readonly notifyOnTaskStartDateChange: boolean | null;
      readonly notifyOnTaskEndDateChange: boolean | null;
      readonly notifyOnTaskSprintChange: boolean | null;
      readonly notifyOnTaskPhaseChange: boolean | null;
      readonly notifyOnTaskStatusColumnChange: boolean | null;
      readonly notifyOnTaskProjectChange: boolean | null;
      readonly notifyOnTaskSubtaskChange: boolean | null;
      readonly notifyOnTaskSubtaskEstimateChange: boolean | null;
      readonly notifyOnTaskCommentChange: boolean | null;
      readonly notifyOnTaskFileChange: boolean | null;
      readonly notifyOnTaskBugChange: boolean | null;
      readonly notifyOnTaskBlockedChange: boolean | null;
      readonly notifyOnTaskRepeatingChange: boolean | null;
      readonly notifyOnInvoiceDueDate: boolean | null;
      readonly notifyOnInvoiceOverdue: boolean | null;
      readonly notifyOnInvoiceDaysOverdue: boolean | null;
      readonly notifyOnInvoiceCreatedOrDeleted: boolean | null;
      readonly notifyOnInvoiceStatusChange: boolean | null;
      readonly notifyOnInvoiceDateReached: boolean | null;
      readonly notifyOnInvoicePayment: boolean | null;
      readonly notifyOnInvoiceDateChanged: boolean | null;
      readonly notifyOnInvoiceDueDateChanged: boolean | null;
      readonly notifyOnTimeOffManager: boolean | null;
      readonly notifyOnTimeOffOwner: boolean | null;
    } | null;
  } | null;
};
export type SetIntegrationNotificationSettingMutation = {
  variables: SetIntegrationNotificationSettingMutation$variables;
  response: SetIntegrationNotificationSettingMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetIntegrationNotificationSettingPayload",
    "kind": "LinkedField",
    "name": "setIntegrationNotificationSetting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSettingsType",
        "kind": "LinkedField",
        "name": "teamsNotificationSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disableNotifications",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnProjectStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnAssignedProject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnPersonJoin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnProjectDeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnAssignedTask",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnAssignedTaskUpdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskDeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnMention",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskDescriptionChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskTitleChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskEstimateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskStartDateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskEndDateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskSprintChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskPhaseChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskStatusColumnChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskProjectChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskSubtaskChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskSubtaskEstimateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskCommentChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskFileChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskBugChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskBlockedChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTaskRepeatingChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceDueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceOverdue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceDaysOverdue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceCreatedOrDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceDateReached",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoicePayment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceDateChanged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnInvoiceDueDateChanged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTimeOffManager",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyOnTimeOffOwner",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetIntegrationNotificationSettingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetIntegrationNotificationSettingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "23ced0f96a89cf9f4b3d79d20dd48018",
    "id": null,
    "metadata": {},
    "name": "SetIntegrationNotificationSettingMutation",
    "operationKind": "mutation",
    "text": "mutation SetIntegrationNotificationSettingMutation(\n  $input: SetIntegrationNotificationSettingInput!\n) {\n  setIntegrationNotificationSetting(input: $input) {\n    teamsNotificationSettings {\n      disableNotifications\n      notifyOnProjectStatusChange\n      notifyOnAssignedProject\n      notifyOnPersonJoin\n      notifyOnProjectDeadline\n      notifyOnAssignedTask\n      notifyOnAssignedTaskUpdate\n      notifyOnTaskDeadline\n      notifyOnMention\n      notifyOnTaskDescriptionChange\n      notifyOnTaskTitleChange\n      notifyOnTaskEstimateChange\n      notifyOnTaskStartDateChange\n      notifyOnTaskEndDateChange\n      notifyOnTaskSprintChange\n      notifyOnTaskPhaseChange\n      notifyOnTaskStatusColumnChange\n      notifyOnTaskProjectChange\n      notifyOnTaskSubtaskChange\n      notifyOnTaskSubtaskEstimateChange\n      notifyOnTaskCommentChange\n      notifyOnTaskFileChange\n      notifyOnTaskBugChange\n      notifyOnTaskBlockedChange\n      notifyOnTaskRepeatingChange\n      notifyOnInvoiceDueDate\n      notifyOnInvoiceOverdue\n      notifyOnInvoiceDaysOverdue\n      notifyOnInvoiceCreatedOrDeleted\n      notifyOnInvoiceStatusChange\n      notifyOnInvoiceDateReached\n      notifyOnInvoicePayment\n      notifyOnInvoiceDateChanged\n      notifyOnInvoiceDueDateChanged\n      notifyOnTimeOffManager\n      notifyOnTimeOffOwner\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2972365c2b31f07cd42221e5a46c45e";

export default node;
